// extracted by mini-css-extract-plugin
export default {"link":"y3yjV","h500":"GtWNl","h400":"_4YUi9","h300":"lohJx","h200":"KJgsc","h100":"AmT4M","b300":"QpgU1","b200":"Vq3Dl","b400":"_3Rsye","b100":"RzGnU"};